import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'mccDate'
})
export class MccDatePipe implements PipeTransform {

    constructor(private datePipe: DatePipe) {
    }

    transform(value: any, showTime: boolean = false, showInLocalTimezone: boolean = false): string {
        let timezone;
        if (!showInLocalTimezone) {
            timezone = '+00:00';
        }
        return this.datePipe.transform(value, `dd.MM.yyyy${showTime ? ' hh:mm a' : ''}`, timezone);
    }

}



// WEBPACK FOOTER //
// /app/src/app/modules/utils/pipes/mcc-date.pipe.ts